import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Flex, Text } from '@rebass/emotion';

import { StepState, Step } from '../Steps/Steps';
import Link from '../Link';
import Checkmark from '../Checkmark';
import styles from './StepDot.styles';

export const CircleWrapper: FC<{
  stepState: StepState;
}> = ({ children, stepState, ...props }) => (
  <Box css={styles.circleWrapper(stepState)} {...props}>
    {children}
  </Box>
);

export interface StepDotProps {
  resetLoading: () => void;
  number: number;
  step: Step;
  stepState: StepState;
}

const StepDot = ({
  number,
  step,
  resetLoading,
  stepState,
}: StepDotProps): JSX.Element => {
  return (
    <Flex
      css={styles.wrapper}
      id={`checkout-navigation-steps-${number}`}
      data-testid={`checkout-navigation-steps-${number}`}
    >
      {stepState.isPassed ? (
        <Link to={step.route} onClick={() => resetLoading()}>
          <CircleWrapper stepState={stepState}>
            <Checkmark data-testid="step-checkmark" color="white" />
          </CircleWrapper>
        </Link>
      ) : (
        <CircleWrapper stepState={stepState}>
          <Text data-testid="number-label" fontSize={1}>
            {number}
          </Text>
        </CircleWrapper>
      )}
      <Text css={styles.label(stepState)}>
        <FormattedMessage {...step.title} />
      </Text>
    </Flex>
  );
};

export default StepDot;
